module.exports = __webpack_public_path__ + "img/08_WebFlow_13-4.04159aaa.svg";